export const mixinHelper = {
  data() {
    return {
      loading: false,
      alert: false,
      alert_type: "success",
      alert_message: "success",
      page: 1,
      totalPages: 1,
      pageSize: 1,
      pageSizes: [100, 200, 500],
    };
  },

  methods: {
    showAlert(alertType, alertMessage) {
      this.alert = true;
      this.alert_type = alertType;
      this.alert_message = alertMessage;
      this.alertTimeOut();
    },

    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    getRequestParams(page, pageSize) {
      let params = {};
      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    
    formatted_filter_date(value) {
      if (value) {
        const inputDate = new Date(value);
        if (!isNaN(inputDate)) {
          const year = inputDate.getFullYear();
          const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
          const date = inputDate.getDate().toString().padStart(2, '0');
          return `${year}-${month}-${date}`;
        }
      }
      return "";
    }
  },
};
